import { SinoNotificacoes } from "../components/SinoNotificacoes";
import { EmpresaSwitcher } from "../components/EmpresaSwitcher";
import { BotaoAjuda } from "./BotaoAjuda";

/**
 * OS BOTÕES DA PONTA DIREITA DO CABEÇALHO — ajuda, sino e troca de empresa.
 *
 * ─── POR QUE ESTE ARQUIVO EXISTE ────────────────────────────────────────────
 * O `<BotaoAjuda />` ia direto no `Layout.tsx`. Mas o `Layout` já é DÍVIDA
 * HERDADA (acima do teto de 800), e o portão de tamanho só aceita a dívida
 * andando pra BAIXO. Código novo em arquivo de dívida reprova — a lição é da
 * sessão OPERADOR, que a pagou duas vezes em 28/08 travando o `main` pra todas
 * as sessões.
 *
 * Então o trio foi extraído pra cá. O `Layout` chama UMA linha (`AcoesDoCabecalho`)
 * no lugar de duas (Sino + EmpresaSwitcher) e fica **menor** do que era antes de
 * a ajuda existir: a dívida andou pra baixo, que é a única direção que o portão
 * aceita.
 *
 * ⚠️ Só COMPOSIÇÃO. Nenhum dos três mudou de comportamento; este arquivo apenas
 * os põe lado a lado. A ordem importa e é da esquerda pra direita: ajuda (o que
 * é esta tela), sino (o que aconteceu), empresa (onde eu estou).
 */
export function AcoesDoCabecalho() {
  return (
    <>
      {/* Some sozinho nas rotas sem ajuda escrita — ver `registroDeAjuda.ts`. */}
      <BotaoAjuda />
      <SinoNotificacoes />
      <EmpresaSwitcher />
    </>
  );
}
